module.exports = __webpack_public_path__ + "img/truc2.2a8a4936.png";